<template>
  <div>
    <a class="options" v-for="button in getCreateButtons" :key="button.id" @click="open(button)">{{ button.name }}</a>
  </div>
</template>

<script>
export default {
  name: 'report-button',
  prop: [ 'buttons', 'dataId' ],
  methods: {
    open (btn) {
      let url = ''
      let dataId = this.dataId
      switch (btn.type) {
        case 'form':
          url = 'form-runtime'
          let formId = btn.targetId
          this.$router.push({name: url, params: { id: formId }, query: {dataId}})
          break
        case 'flow':
          url = 'flow-runtime'
          let flowId = btn.targetId
          this.$router.push({name: url, params: { id: flowId }, query: {dataId}})
          break
        default:
          throw new Error('未知的按钮类型')
      }
    }
  },
  computed: {
    getCreateButtons () {
      if (this.buttons) {
        return this.buttons.filter(m => m.type === 'update' || m.type === 'delete')
      }
    }
  }
}
</script>
<style>
  .options{
    font-size: 15px;
    cursor: pointer;
    padding-right: 4px;
    color: #409eff;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/report-button.vue